<template>
    <div class="new_indexAdmin">
         <div class="u-max-width  ERPShopAdminbanner">
               <!-- <video class="indexVideo" autoplay muted  loop x5-video-player-type="h5" 
               x5-video-orientation="portraint" webkit-playsinline playsinline  x5-playsinline
               src="../../../assets/images/newImg/index2.mp4"> </video>   -->
    
               <div class="ERPShop-bannnertext">
                  <div class="ERPShop-bannnertext1">一站式物联网和云通信解决方案服务商</div>
                  <div class="ERPShop-bannnertext2">智慧城市、智慧医疗、智能穿戴、智慧金融、智能安防、无线路由（工业、家庭）</div>
                  <div class="ERPShop-bannnerbtn">
                       <!-- <div class="bannnerbtn" @click="handleClick('/corporationAdmin')">立即查看</div> -->
                  </div>
               </div>
             
        </div>
          <div class="u-max-width  ERPShopAdminbannergif">
               <img src="../../../assets/images/newImg/indexGif.gif">
              
               <!-- <div class="ERPShop-bannnertext">
                  <div class="ERPShop-bannnertext1">ONEBO一件分销出海平台</div>
                  <div class="ERPShop-bannnertext2">简单做跨境，一产品卖全球</div>
                  <div class="ERPShop-bannnerbtn">
                       <div class="bannnerbtn" @click="handleClick('/corporationAdmin')">立即查看</div>
                  </div>
               </div> -->
             
        </div>
        <div class="u-max-width u-p-t-100 u-p-b-100  u-p-l-200 u-p-r-200" style="background:#FFF"> 
            <div class="u-min-width u-flex u-row-center u-col-center u-p-50" >
                <div >
                    <h1 class="u-p-b-20">创芯科技</h1>
                    <div class="u-p-b-40">一站式物联网和云通信解决方案服务商</div>
                    <div  class="u-p-b-100">创芯时代（深圳）技术有限公司专注物联网综合解决方案、物联云平台开发及物联网运营等。是集物联网软件、云平台和大数据服务于一体的创芯型物联网企业，与四大运营商（移动、联通、电信。广电）在全国十几个省份200多个地市已达成战略合作，是国内领先物联网专业的云通信服务提供商和服务商。
                    </div>
                    <div class="u-flex u-row-center">
                        <div class="numberItem">
                            <div style="color:#fff">6800+</div>
                            <div>月活跃企业客户</div>
                        </div>
                        <div class="numberItem">
                            <div>1亿+</div>
                            <div>API日均访问量</div>
                        </div>
                        <div class="numberItem">
                            <div>4680万+</div>
                            <div>累计连接终端数</div>
                        </div> 
                    </div>
                </div>
               <div>
                <img src="../../../assets/myimage/image.webp" alt="">
               </div>
            </div>
        </div>
        <div class="recruitmentItem5 u-p-t-40  u-max-width">
            <div class="u-min-width">
                <div class="generalViewTitle">
                    <div class="generalViewTitle1">PLATFORM  ADVANTAGE</div>
                    <div class="generalViewTitle2">产品与解决方案 <img src="../../../assets/images/newImg/tubiao1.png"></div>
                </div>
            </div> 
             <div class="u-min-width u-m-t-60 u-p-b-160 supplierAdminItem4">
                   <ul class="supplierAdminItem4-ul u-flex u-row-between">
                        <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                <img style="width:100%" src="../../../assets/myimage/pingtai001.jpeg">
                            </div>
                            <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">物联网连接管理平台</div>
                                    <div class="ul-li-titlt2 u-m-t-20">全球领先的物联网连接运营管理平台</div>
                                 </div>
                                <img class="u-m-t-20 u-m-l-50" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/myimage/logo.png">
                            </div>
                            
                        </li>
                         <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                <img style="width:100%" src="../../../assets/myimage/APP01.jpg">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">芯动云App</div>
                                    <div class="ul-li-titlt2 u-m-t-20">一款集快速实名认证、流量充值、流量查询、客服支持于一体的专用功能性软件</div>
                                 </div>
                                <img class="u-m-t-20 u-m-l-50" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/myimage/logo.png">
                            </div>
                        </li>
                        <li>
                            <div  class="u-flex u-row-center" style="width:100%">
                                 <img style="width:100%" src="../../../assets/myimage/wulianwangka.webp">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">物联网卡</div>
                                    <div class="ul-li-titlt2 u-m-t-20">支持国内三大运营商和国际运营商网络，网络覆盖全球200多个国家和地区</div>
                                 </div>
                                <img class="u-m-t-20 u-m-l-50" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/myimage/logo.png">
                            </div>
                        </li>
                   </ul>
                    <ul class="supplierAdminItem4-ul u-flex u-row-between u-m-t-20">
                        <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                 <img style="width:100%" src="../../../assets/myimage/ufi.jpg">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">UFI</div>
                                    <div class="ul-li-titlt2 u-m-t-20">多口兼容，灵巧随行，网速快、流量足、花费省</div>
                                 </div>
                                <img class="u-m-t-20 u-m-l-50" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/myimage/logo.png">
                            </div>
                           
                        </li>
                         <li>
                            <div class="u-flex u-row-center" style="width:100%">
                                <img style="width:100%" src="../../../assets/myimage/mifi.jpg">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">MIFI</div>
                                    <div class="ul-li-titlt2 u-m-t-20">网速快、信号稳定、随身便携</div>
                                 </div>
                                <img class="u-m-t-20 u-m-l-50" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/myimage/logo.png">
                            </div>
                          
                        </li>
                        <li>
                            <div  class="u-flex u-row-center" style="width:100%">
                                 <img style="width:100%" src="../../../assets/myimage/cpe02.jpg">
                            </div>
                             <div class="supplierAdminItem4box">
                                <div class="u-p-l-60 u-p-r-60">
                                    <div class="ul-li-titlt1 u-m-t-20">CPE</div>
                                    <div class="ul-li-titlt2 u-m-t-20">5G全网通、支持WIFI6多设备上网不排队</div>
                                 </div>
                                <img class="u-m-t-20 u-m-l-50" style="width:120px;margin-bottom:20px;float:left" src="../../../assets/myimage/logo.png">
                            </div>
                            
                        </li>
                        
                   </ul>
             </div>
        </div>
        <div class="recruitmentItem6 u-p-t-60 u-p-b-100 u-max-width" style="background:#f7f9fc">
            <div class="u-min-width">
                <div class="generalViewTitle">
                    <div class="generalViewTitle1" style="color:#dad9d9">PLATFORM  ADVANTAGE</div>
                    <div class="generalViewTitle2" style="color:#000">营销网络 <img src="../../../assets/images/newImg/tubiao1.png"></div>
                </div>
                <div style="color:#000;font-size:20px">目前创芯科技的营销网络已经覆盖了全国各大中重点城市区域，并在全国规划布局多个分支机构与合作办事单元与此同时还与中国移动、中国联通、中国电信国内三大运营商达成深度战略合作，覆盖到了全国的市场</div>
                <div class="recruitmentItem6View u-m-t-40">
                    <img src="../../../assets/myimage/wangluo.png" class="recruitmentItem6View-img" alt="">
                    <div class="recruitmentItem6ViewItem recruitmentItem6ViewItem1">
                       <div class="mytitle">4680万+</div>
                       <div class="ctitle">累计连接终端数</div>
                    </div>
                    <div class="recruitmentItem6ViewItem recruitmentItem6ViewItem2">
                        <div class="mytitle">6800+</div>
                        <div class="ctitle">月活跃企业客户</div>
                    </div>
                    <div class="recruitmentItem6ViewItem recruitmentItem6ViewItem3">
                        <div class="mytitle">1亿+</div>
                        <div class="ctitle">API日均访问量</div>
                    </div>  
                </div>
            </div>
        </div>
        
        <div class="recruitmentItem7 u-max-width u-p-t-100 u-p-b-100">
             <div class="u-min-width">
                 <div class="generalViewTitle">
                    <div class="generalViewTitle1">ENTERPRIISE  MISSION</div>
                    <div class="generalViewTitle2">以客户为中心的管家式服务 <img src="../../../assets/images/newImg/tubiao1.png"></div>
                </div>
                <div style="color:#fff;font-size:20px">成熟的服务运维体系，7X16小时在线技术支持，全方位助力</div>
                <div class="generalItemView u-m-t-40">
                    <div class="generalItem" @click="handleClick('/civilizationAdmin')">
                        <div>
                            <div class="generalItemtext1 u-m-t-40 u-m-l-60">7x16h</div>
                            <div class="generalItemtext2 u-m-t-10 u-m-l-60">服务时间</div>
                        </div>
                    </div>
                    <div class="generalItem" @click="handleClick('/civilizationAdmin')">
                        <div>
                            <div class="generalItemtext1 u-m-t-40 u-m-l-60">10000+</div>
                            <div class="generalItemtext2 u-m-t-10 u-m-l-60">需求解决数量</div>
                        </div>
                    </div>
                    <div class="generalItem" @click="handleClick('/civilizationAdmin')">
                        <div>
                            <div class="generalItemtext1 u-m-t-40 u-m-l-60">99%</div>
                            <div class="generalItemtext2 u-m-t-10 u-m-l-60">客户满意度</div>
                        </div>
                    </div>
                </div>
              </div>
        </div>
        <div class="u-max-width u-p-t-100 u-p-b-100" style="background:#FFF"> 
            <div class="u-min-width u-flex u-row-center u-col-center" style="flex-direction: column;">
                <div class="indexTitle1">荣誉资质</div>
                <div class="u-m-t-80 zizhi">
                    <img src="../../../assets/myimage/ruanzhu1.jpg" alt="" class="u-m-r-20">
                    <img src="../../../assets/myimage/ruanzhu2.jpg" alt="" class="u-m-r-20">
                    <img src="../../../assets/myimage/ruanzhu3.jpg" alt="" class="u-m-r-20">
                    <img src="../../../assets/myimage/ruanzhu4.jpg" alt="" class="u-m-r-20">
                </div>
            </div>
            <div class="u-min-width u-flex u-row-center u-col-center" style="flex-direction: column;margin-top:40px">
                <div class="indexTitle1">合作伙伴</div>
                <div class="u-m-t-80 zizhi">
                    <img src="../../../assets/myimage/logos.webp" alt="" style="width:1215px;height:622px" >
                  
                </div>
            </div>
        </div>
        <div class="recruitmentItem7 u-max-width u-p-t-100 u-p-b-100">
            <div class="u-min-width">
                <div class="generalViewTitle" style="padding-bottom:40px">
                   <div class="generalViewTitle2">联系我们 <img src="../../../assets/images/newImg/tubiao1.png"></div>
               </div>
               <div class="generalItemView u-m-t-40 " >
                    <div id="AddressMap"></div>
               </div>
             </div>
       </div>
        <myNewFoot :show="false"></myNewFoot>
    </div>
</template>
<script>
import BMap from "BMap"
import myNewMenu from "@/components/newcomponents/myNewMenu"
import myNewFoot from "@/components/newcomponents/myNewFoot"
import myContern from "@/components/newcomponents/myContern"
export default {
    name:'new_indexAdmin',
    data(){
        return {

        }
    },
    components:{
        myNewMenu,
        myNewFoot,
        myContern
    },
    mounted() {
        // this.menuSeen()
        // window.addEventListener('scroll', this.handleScroll)
        // this.sliders = [
        //     {
        //         img: require("../assets/slider/a1.jpg")
        //     },
        //     {
        //         img: require("../assets/slider/a2.jpg")
        //     },
        //     {
        //         img: require('../assets/slider/a3.jpg')
        //     },
        //     {
        //         img: require('../assets/slider/a4.jpg')
        //     }
        // ]

        let map = new BMap.Map("AddressMap");
        
        var point = new BMap.Point(113.926948,22.773685);
        map.centerAndZoom(point, 18);
        map.enableScrollWheelZoom();
        var marker = new BMap.Marker(point);// 创建标注
        map.addOverlay(marker);             // 将标注添加到地图中
    },
    methods:{
          handleClick(url){
            this.$router.push({
                path:url
            })
          }
    }
    
}
</script>
<style lang="scss" scoped>
 .new_indexAdmin{
    font-family: PingFang SC-Regular, PingFang SC;
    .generalViewTitle{
        position: relative;
   }
   #AddressMap {
    width: 1200px;
    height: 500px;
    margin: 0 auto;
}
.numberItem{
    width: 180px;
    height: 80px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: #f0f0f0 1px solid;
    font-weight: bold;
   div:first-child{
        font-size: 24px;
        font-style: italic;
        color: #127bf2;
   }
}
.numberItem:first-child{
  background: #127bf2;
  color: #fff !important;
}
   .generalViewTitle1{
        font-size: 90px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        opacity: 0.6;
   }
    .generalViewTitle2{
       position: absolute;
       z-index: 10;
       top: 50%;
       left: 0;
       transform: translateY(-50%);
       font-size: 38px;
       font-family: PingFang SC-Semibold, PingFang SC;
       font-weight: 600;
       color: #FFF;
   }
     .ERPShopAdminbanner{
        //  background: url("../../../assets/images/newImg/indexGif.gif");
        //  background-size: 100% 100%;
         height: 868px;
         .indexVideo{
            width: 100%;
            height: 100%;
          
         }
         .ERPShop-bannnertext{
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-image: url("../../../assets/myimage/bg.png") ;
            background-size:cover ;
            .ERPShop-bannnertext1{
                font-size: 78px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
            }
            .ERPShop-bannnertext2{
               margin-top: 100px;
               font-size: 40px;
               font-family: PingFang SC-Regular, PingFang SC;
               font-weight: 400;
               color: #FFF;
            }
            .ERPShop-bannnerbtn{
                display: flex;
                margin-top: 100px;
                & div{
                    width: 200px;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;
                    font-size: 18px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    cursor: pointer;
                }
                .bannnerbtn{
                    background: linear-gradient(90deg, #FC6B1D 0%, #F98F43 100%);
                    color: #fff;
                }
                .bannnerbtn2{
                    margin-left: 20px;
                    
                    color: #FD681C

                }
            }
         }
    }
    .ERPShopAdminbannergif{
        display:none;
       
    }
   .indexTitle1{
       font-size: 40px;
       font-family: PingFang SC-Semibold, PingFang SC;
       font-weight: 600;
       color: #000000;
       background: transparent;
       position: relative;
       z-index: 10;
   }
   .zizhi{
    display: flex;
    justify-content: space-between;
    align-items: center;
   }
   .zizhi img{
  width: 130px;
  height: 180px;
   }
   .indexTitle1:before{
        content: '';
        display: inline-block;
        width:110%;
        height: 10px;
        background:  #FC7632 ;
        position: absolute;
        left: 50%;
        bottom: 2px;
        z-index: -1;
        transform: translateX(-50%);
   }
   .indexTitle2{
       font-size: 16px;
       font-family: PingFang SC-Regular, PingFang SC;
       font-weight: 400;
       color: #999999;
   }
   .indexTitle3{
       font-size: 16px;
       font-family: PingFang SC-Regular, PingFang SC;
       font-weight: 400;
       color: #333333;
       padding: 0 200px;
       text-align: center;
   }
  
   .recruitmentItem5{
        background: #010101;
       .supplierAdminItem4{
        .supplierAdminItem4Title{
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #000000;
        }
        .supplierAdminItem4Title2{
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
        }
        .supplierAdminItem4-ul{
            li{
                width: 457px;
                height: 457px;
                background:#FFF ;
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                 overflow: hidden;
                 position: relative;
                 cursor: pointer;
                .supplierAdminItem4box{
                    position: absolute;
                    bottom:  -120px;
                    left: 0;
                    background: #FFF;
                    width: 100%;
                    transition:bottom 1s ease-in-out ;
                     .ul-li-titlt1{
                            font-size: 21px;
                            font-family: PingFang SC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #010101;
                            text-align: left;
                        }
                        .ul-li-titlt2{
                            font-size: 15px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #555555;
                            text-align: left;
                            height: 40px;
                        
                        }
                }
                &:hover{
                    .supplierAdminItem4box{
                        bottom:0;
                    }
                }
               
            }
        }
    }
   }
    .recruitmentItem6View{
       display: flex;
       justify-content: space-between;
       align-items: center;
       background: #f7f9fc;
       position: relative;
       .recruitmentItem6View-img{
        margin: 0 auto;
        
     }
     .recruitmentItem6ViewItem{
        width: 179px;
        height: 83px;
        border: 1px solid;
        position: absolute;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        -o-border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
        border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
        .mytitle{
            font-size:2.25rem;
            color: #127bf2;
        }
        .ctitle{
            font-size:.875rem;
            color: #343e4c;
        }
       }
       .recruitmentItem6ViewItem1{
        top: 2%;
        left: 15%;
       }
       .recruitmentItem6ViewItem2{
        top: 5%;
        right: 8%;
       }
       .recruitmentItem6ViewItem3{
        bottom: 8%;
        left:25%;
       }
   }
   
   .recruitmentItem7{
        background: #000000;
   }
 
   .generalItemView{
      display: flex;
      justify-content: space-between;
      align-items: center;
   }
   .generalItem{
      color: #fff;
   }
   .generalItemtext1{
        font-size: 28px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #f1f1f1;
   }
   .generalItemtext2{
        font-size: 18px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666666;
   }
   
 }
 
</style>
<style lang="scss" scoped>
/*手机端*/
@media  screen and (max-width:760px) {
    .generalViewTitle1{
        font-size: 40px !important;
       
   }
    .generalViewTitle2{
       font-size: 18px !important;
   }
    .ERPShopAdminbanner{
        display: none !important;
         height: 190px !important;
         position: relative;
         .indexVideo{
            width: 100%;
            height: 190px !important;
         }
         .ERPShop-bannnertext{
            .ERPShop-bannnertext1{
                font-size: 20px !important;
                margin-top: 60px;
            }
            .ERPShop-bannnertext2{
               margin-top: 20px !important;
               font-size: 12px !important;
            }
            .ERPShop-bannnerbtn{
                display: flex;
                margin-top: 20px !important;
                & div{
                    width: 90px !important;
                    height: 25px !important;
                    line-height: 25px !important;
                    font-size: 12px !important;
                }
              
            }
         }
    }

    .ERPShopAdminbannergif{
        display:block !important;
         height: 190px !important;
         & img{
            width: 100%;
            height: 190px !important;
         }
    }
   .indexTitle1{
       font-size:24px !important;
       
   }
   .indexTitle1:before{
        height: 4px !important;
       
   }
   .indexTitle2{
       font-size: 16px;
   }
   .indexTitle3{
       font-size: 14px !important;
       padding: 0 10px !important;
   }
   .indeximg1{
       width:96%;
   }
     .recruitmentItem5{
        background: #010101;
       .supplierAdminItem4{
        .supplierAdminItem4Title{
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #000000;
        }
        .supplierAdminItem4Title2{
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
        }
        .supplierAdminItem4-ul{
            flex-direction: column;
            li{
                width: 100% !important;
                height: 457px;
                background:#FFF ;
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                 overflow: hidden;
                 position: relative;
                 cursor: pointer;
                 margin-bottom: 16px !important;
                .supplierAdminItem4box{
                    position: absolute;
                    bottom:  -140px;
                    left: 0;
                    bottom:0 !important;
                    
                }
               
               
            }
        }
    }
   }
    .recruitmentItem6View{
       display: flex;
       flex-direction: column;
       position: relative;
       background: #f7f9fc;
       .recruitmentItem6View-img{
        margin: 0 auto;
      }
       .recruitmentItem6ViewItem{
        width: 179px;
        height: 83px;
        border: 1px solid;
        -o-border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
        border-image: linear-gradient(0deg, #127bf2, #c1deff) 10 10;
       }
   }
   
   .recruitmentItem7{
        background: #000000;
   }
 
   .generalItemView{
     flex-direction: column;
   }
   .generalItem{
      width: 100% !important;
      height: 610px;
      background: #FFFFFF;
   }
   .generalItem img{
       width: 100%;
       height: 457px;
   }
   .generalItemtext1{
        font-size: 28px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
   }
   .generalItemtext2{
        font-size: 18px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666666;
   }
   
}
</style>
